module.exports = __webpack_public_path__ + "img/chehui.f5bf95e3.png";